/**
 * Canonical site host. Single source of truth for SEO output
 * (canonical, sitemap, og:url, JSON-LD URLs).
 * Apex (no www) per migration decision B.
 */
export const SITE_URL = "https://ikhlastour.com";

/**
 * Build a fully-qualified canonical URL for a route path.
 *
 * S3 static-website hosting issues a 301 redirect from `/foo` to `/foo/` so
 * every non-root canonical must end with a trailing slash; otherwise Googlebot
 * follows a 301 on each crawl and the canonical signal is muddied. Root `/`
 * stays as `${SITE_URL}/`.
 */
export const canonicalUrl = (path: string): string => {
  const withSlash = path === "/" || path.endsWith("/") ? path : `${path}/`;
  return `${SITE_URL}${withSlash}`;
};

/**
 * Build a fully-qualified URL for an image asset.
 *
 * Image files (hero / featured / vehicle photos) live on the media CloudFront
 * distribution, not on the main site host — so og:image, twitter:image, and
 * JSON-LD image fields must be prefixed with VITE_CLOUDFRONT_URL. If the
 * passed `path` is already absolute, return it unchanged.
 */
export const assetUrl = (path: string): string => {
  if (path.startsWith("http")) return path;
  const base = import.meta.env.VITE_CLOUDFRONT_URL ?? SITE_URL;
  return `${base}${path}`;
};
